const B_1 = [
    {
        title: '项目列表',
        path: '/bidding/zbr/zbprojectpermission/list'
    }
]

export default {
    path: 'zbprojectpermission',
    component: () => import(/*webpackChunkName: 'zbr-project'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/zbr/zbprojectpermission/list'),
            meta: {
                title: '招标项目列表',
                bread: B_1,
                topNav: true,
            },
        },
        {
            path:"linklist",
            component: () => import('@views/bidding/views/zbr/zbprojectpermission/linklist'),
            meta: {
                title: '添加项目',
                bread: B_1,
            },
        },
    ]
}
